import { dashboardLink, loginErrorLink } from 'src/router/routerLink';

import { Box } from '@mui/material';
import Login from '../../content/pages/Auth/Login/Cover';
import Logo from '../../components/Logo';
import { Navigate } from 'react-router-dom';
import React from 'react';
import useAuth from '../../hooks/useAuth';
import { parseErrorJson } from 'src/content/pages/Auth/Login/helper';

const AppInit = () => {
  const auth = useAuth();

  if (auth.error) {
    const errorJson = parseErrorJson(auth.error.message);
    if (errorJson === null) {
      return <Navigate to={loginErrorLink} replace />;
    }
  }

  if (auth.isAuthenticated) {
    const targetPath = sessionStorage.getItem("requestedPath") || dashboardLink;
    sessionStorage.removeItem("requestedPath");
    return <Navigate to={targetPath} replace />
  }

  if (auth.isLoading) {
    return (
      <Box
        sx={{
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          right: 0,
          width: '100%',
          height: '100%'
        }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Logo />
      </Box>
    )
  }

  return <Login />
};

export default AppInit;